import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ResultsViewComponent } from './components/results-view/results-view.component';
import { AdvSearchViewComponent } from './components/adv-search-view/adv-search-view.component';
import { SearchResolverService } from './resolvers/search-resolver.service';
import { MetadataResolverService } from './resolvers/metadata-resolver.service';
import { DocPropertiesViewComponent } from './components/doc-properties-view/doc-properties-view.component';
import { PropertyViewResolverService } from './resolvers/property-view-resolver.service';
import { GlossaryViewComponent } from './components/glossary-view/glossary-view.component';
import { LastIndexDateResolverService } from './resolvers/last-index-date-resolver.service';
import { ErrorViewComponent } from './components/error-view/error-view.component';
import { HomeCleanViewComponent } from './components/home-clean-view/home-clean-view.component';
import { LandingComponent } from './components/landing/landing.component';
import { AllFoldersResolverService } from './resolvers/all-folders-resolver.service';
import { handshakeGuardGuard } from './guards/handshake.guard';

const routes: Routes = [
    { path: '', redirectTo: '/home', pathMatch: 'full' },
    { path: 'home', component: HomeCleanViewComponent, resolve: { folders: AllFoldersResolverService, metadataProps: MetadataResolverService, indexDate: LastIndexDateResolverService}, canMatch: [handshakeGuardGuard], runGuardsAndResolvers: 'paramsChange' },
    // { path: 'home', component: HomeCleanViewComponent, resolve: { cert: AppHandshakeResolverService }, runGuardsAndResolvers: 'paramsChange' },
    { path: 'results/:q', component: ResultsViewComponent, resolve: { results: SearchResolverService, indexDate: LastIndexDateResolverService }, canMatch: [handshakeGuardGuard], runGuardsAndResolvers: 'paramsChange' },
    { path: 'adv-search', component: AdvSearchViewComponent, resolve: { metadataProps: MetadataResolverService, indexDate: LastIndexDateResolverService }, canMatch: [handshakeGuardGuard], runGuardsAndResolvers: 'paramsChange' },
    { path: 'props/:id', component: DocPropertiesViewComponent, resolve: { props: PropertyViewResolverService, indexDate: LastIndexDateResolverService }, canMatch: [handshakeGuardGuard] },
    { path: 'terms', component: GlossaryViewComponent, resolve: {indexDate: LastIndexDateResolverService }, canMatch: [handshakeGuardGuard],},
    { path: 'error', component: ErrorViewComponent},
  ];

  @NgModule({
    imports: [RouterModule.forRoot(routes, {anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled'})],
    exports: [RouterModule]
  })
  export class AppRoutingModule { }
  
